import React from 'react';
import CustomTypes from "Flow2/components/CustomCollections/CustomDataConfig/CustomDataTypes";

const getDocElementId = (element, option) => {
    switch (option) {
        case 'project':
            return CustomTypes.SINGLEPROJECT_BTN_ID + element["id"];
        case 'room':
            return CustomTypes.SINGLEROOM_BTN_ID + element["id"];
        case CustomTypes.SINGLEROOM:
            return option + element["id"];
        case CustomTypes.SINGLEPROJECT:
            let id = element.data.id || element["id"];
            return option + id;
        default:
            return;
    }
}

const refeshElements = ({ elements, option }) => {
    for (let element of elements) {
        let id = element.data.id || element["id"];
        let el = document.getElementById(`${option}${id}`);
        if (el) {
            if (el.style && el.style.background) el.style.background = CustomTypes.CUSTOM_UNSET;
            let childDiv = el.children[1];
            if (childDiv && childDiv.style && childDiv.style.background) childDiv.style.background = CustomTypes.CUSTOM_UNSET;
        }
        if (element.children) refeshElements({ elements: element.children, option });
    }
}

const deactivateOthers = (el) => {
    if (el && el.style && el.style.background) {
        el.style.background = CustomTypes.CUSTOM_UNSET;
    }
    let children = el.children;
    if (children) {
        for (let i = 0; i < children.length; i++) {
            let child = children[i];
            if (child) deactivateOthers(child);
        }
    }
}

const handleOthers = ({ others, option }) => {
    if (others) {
        for (let i in others) {
            if (i.includes("customClicked") && i !== `customClicked${option}`) {
                let el = document.getElementById(others[i]);
                deactivateOthers(el);
            }
        }
    }
}

const setInitTree = ({ parent, elements, option, others }) => {
    handleOthers({ others, option });
    if (elements && option.includes(CustomTypes.SINGLEPROJECT)) {
        refeshElements({ elements, option });
    }
    if (parent && parent.id) {
        let parentElement = document.getElementById(`${option}${parent.id}`);
        if (parentElement) parentElement.style.background = CustomTypes.CUSTOM_UNSET;
    }
}

const refreshTree = ({ projectElement, option, id, elementId }) => {
    projectElement.style.background = CustomTypes.CUSTOM_UNSET;
    let childDiv = projectElement.children[1];
    if (childDiv) childDiv.style.background = CustomTypes.CUSTOM_UNSET;

    if (id === `${option}${elementId}`) {
        if (option.includes(CustomTypes.SINGLEPROJECT)) {
            let childDiv = projectElement.children[1];
            if (childDiv) childDiv.style.background = CustomTypes.CUSTOM_ACTIVE;
            else projectElement.style.background = CustomTypes.CUSTOM_ACTIVE;
        } else {
            projectElement.style.background = CustomTypes.CUSTOM_ACTIVE;
        }
    }
}

export const setActiveElement = (elementId, elements, option, parent = null, others = null) => {
    try {
        if (option.includes('Single')) setInitTree({ parent, elements, option, others });
        for (let element of elements) {
            if (element.hasOwnProperty("id") || element.data.id) {
                let id = getDocElementId(element, option);
                let projectElement = document.getElementById(id);
                if (projectElement) {
                    if (option.includes('Single')) {
                        refreshTree({ projectElement, option, id, elementId });
                    } else {
                        projectElement.style.border = CustomTypes.PROJECT_BORDER;
                        if (id === elementId) {
                            projectElement.style.border = CustomTypes.PROJECT_BORDER_ACTIVE;
                        }
                    }
                }
            }
        }
    } catch (error) {
        console.log("LAMTEST setActiveElement ERROR");
    }
}

export const getDeletedItem = ({ elements, currentItem, deletedElements }) => {
    if (elements && currentItem && currentItem.id) {
        let liveItem = elements.find(item => parseInt(item.id) === parseInt(currentItem.id));
        if (deletedElements) {
            let found = deletedElements[`${currentItem.id}`];
            if (!liveItem && found) return true;
        }
        if (!liveItem) return true;
    }
    return false;
}